routing.$inject = ['$stateProvider'];

export default function routing($stateProvider) {
    
    $stateProvider
        .state('dashboard', {
            url: "/",
            abstract: true
        }).state('dashboard.index', {
        url: '',
        template: require('../../../views/dashboard/dashboard.html'),
        controller: 'DashboardCtrl',
        controllerAs: 'dashboard'
    });
}
